import React, { Fragment, useEffect, useState } from "react";


export function Input({ initialValue, initialValueObject, initialValueKey, name, label, type, description, className, isValid, validFeadBack, invalidFeedback, disabled, autoComplete }){
	
	const [value, setValue] = useState('');
	
	function onChange(event){
		setValue(event.target.value);
	}

	useEffect( () => {
		if(initialValue){
			setValue(initialValue); }
	}, [initialValue]);

	useEffect( () => {
		if(initialValueObject && initialValueKey){
			setValue( initialValueObject[initialValueKey] || '');
		}
	}, [initialValueObject, initialValueKey]);

	if(!type){
		type = "text"; }

	if(!className){
		className = 'form-group'; }

	let inputClass = 'form-control';
	
	if(isValid === true){
		inputClass += ' is-valid'; 
	}else if(isValid === false){
		inputClass += ' is-invalid'; }

	return (<div className={className}>				
		<label className="w-100">{label}
			<input className={inputClass}
				name={name} value={value} onChange={onChange} type={type} 
				spellCheck="false" autoCapitalize="off" autoComplete={autoComplete || 'off'} autoCorrect="off" disabled={disabled} />
			{isValid === true && validFeadBack && <div className="valid-feedback">{validFeadBack}</div>}
			{isValid === false && invalidFeedback && <div className="invalid-feedback">{invalidFeedback}</div>}
			{description && <small className="form-text text-muted">{description}</small>}
		</label>
	</div>);
}

export function DropDown({ name, label, dataState, dataArrayKey, onChange, description }){

	const [selected, setSelected] = useState('');

	function onChangeHandler(event){
		setSelected(event.target.value);
		if(onChange){
			onChange(event.target.value); }
	}

	let element = null;

	if(dataState.isLoading){
		element = (<div className="clearfix">
			<div className="spinner-border text-primary float-left" role="status">
				<span className="sr-only">Obteniendo datos...</span></div></div>);

	}else if(dataState.isError){
		element = (<span>API Error!</span>);
	}else if(dataState.data){
		const options = dataState.data[dataArrayKey];
		element = (<select className="form-control" name={name} value={selected} onChange={onChangeHandler}>
			<option value=""> -- selecciona una opción -- </option>
			{options && options.map( (option) => <option key={option.id} value={option.id}>{option.name}</option> )}
		</select>);
	}else{
		return (<Fragment />);
	}

	
	return (<div className="form-group">
		<label className="w-100">{label}
			{element}
			{description && <small className="form-text text-muted">{description}</small>}
		</label>
	</div>);
}
